export async function fetchProducts() {
    return window.axios.get('/products');
}


export async function saveProduct(product) {
    return window.axios.post('/products', product);
}


export async function updateProduct(updatedProduct) {
    updatedProduct.append('_method', 'PUT');
    updatedProduct.delete('media');

    return window.axios.post(`/products/${updatedProduct.get('id')}`, updatedProduct);
}

export async function deleteProduct(product) {
    return window.axios.delete(`/products/${product.id}`);
}
